module.exports = __webpack_public_path__ + "img/nc.11614fc4.svg";